declare module "@mui/material/styles" {
  // interface PaletteOptions {}
  interface TypeBackground {
    dark: TypeBackground["default"]
    body: TypeBackground["default"]
  }
  interface TypeText {
    third: TypeText["primary"]
    forth: TypeText["primary"]
    border: TypeText["primary"]
    outline: TypeText["primary"]
    custom: TypeText["primary"]
  }
}

import { createTheme } from "@mui/material"

export const DefaultTheme = createTheme({
  palette: {
    background: {
      default: "#FFFFFF",
      paper: "#F4EDE7",
      body: "#FBFAF4",
      dark: "#222222",
    },
    primary: {
      main: "#1F6757",
      dark: "#7DC522",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#222222",
      dark: "#FFFFFF",
      contrastText: "#FFFFFF",
    },
    text: {
      primary: "#222222",
      secondary: "#FFFFFF",
      third: "#97CE75",
      forth: "#7EC3D9",
      custom: "#E5DACE",
      border: "#F66450",
      outline: "#D4D3D7",
      disabled: "#C8C8C8",
    },
    divider: "#D9D9D9",
  },
})
